module.exports = __webpack_public_path__ + "static/media/NFPA.69abf0a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/NFPA.svg
// module id = 77
// module chunks = 0